import styled from "styled-components";

import { Modal, Button as ButtonAnt } from "antd";

export const Container = styled(Modal)``;

export const Button = styled(ButtonAnt)``;
